<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
  >
    <div class="trezo-card-content">
      <code
        class="p-[15px] md:p-[20px] block bg-[#f5f2f0] dark:bg-[#15203c] text-[.875em] break-words text-[#d63384] text-base"
      >
        &lt;<span class="text-[#905] ltr:mr-[5px] rtl:ml-[5px]">span</span
        ><span class="text-[#690]">class</span>=<span class="text-[#07a]"
          >&quot;material-symbols-outlined&quot;</span
        >&gt;search&lt;/<span class="text-[#905]">span</span>&gt;
      </code>
    </div>
  </div>
  <div
    class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-6 2xl:grid-cols-6 gap-[25px] mb-[25px]"
  >
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> search </span>
        <span class="block mt-[20px] md:mt-[35px]"> search </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> home </span>
        <span class="block mt-[20px] md:mt-[35px]"> home </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> menu </span>
        <span class="block mt-[20px] md:mt-[35px]"> menu </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> close </span>
        <span class="block mt-[20px] md:mt-[35px]"> close </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> settings </span>
        <span class="block mt-[20px] md:mt-[35px]"> settings </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> done </span>
        <span class="block mt-[20px] md:mt-[35px]"> done </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> expand_more </span>
        <span class="block mt-[20px] md:mt-[35px]"> expand_more </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> search </span>
        <span class="block mt-[20px] md:mt-[35px]"> search </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> check_circle </span>
        <span class="block mt-[20px] md:mt-[35px]"> check_circle </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> favorite </span>
        <span class="block mt-[20px] md:mt-[35px]"> favorite </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> add </span>
        <span class="block mt-[20px] md:mt-[35px]"> add </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> arrow_back </span>
        <span class="block mt-[20px] md:mt-[35px]"> arrow_back </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> star </span>
        <span class="block mt-[20px] md:mt-[35px]"> star </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> chevron_right </span>
        <span class="block mt-[20px] md:mt-[35px]"> chevron_right </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> logout </span>
        <span class="block mt-[20px] md:mt-[35px]"> logout </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> arrow_forward_ios </span>
        <span class="block mt-[20px] md:mt-[35px]"> arrow_forward_ios </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> add_circle </span>
        <span class="block mt-[20px] md:mt-[35px]"> add_circle </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> cancel </span>
        <span class="block mt-[20px] md:mt-[35px]"> cancel </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> arrow_back_ios </span>
        <span class="block mt-[20px] md:mt-[35px]"> arrow_back_ios </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> arrow_forward </span>
        <span class="block mt-[20px] md:mt-[35px]"> arrow_forward </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> arrow_drop_down </span>
        <span class="block mt-[20px] md:mt-[35px]"> arrow_drop_down </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> check </span>
        <span class="block mt-[20px] md:mt-[35px]"> check </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> check_box </span>
        <span class="block mt-[20px] md:mt-[35px]"> check_box </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> toggle_on </span>
        <span class="block mt-[20px] md:mt-[35px]"> toggle_on </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> open_in_new </span>
        <span class="block mt-[20px] md:mt-[35px]"> open_in_new </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> grade </span>
        <span class="block mt-[20px] md:mt-[35px]"> grade </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> refresh </span>
        <span class="block mt-[20px] md:mt-[35px]"> refresh </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> check_box_outline_blank </span>
        <span class="block mt-[20px] md:mt-[35px]">
          check_box_outline_blank
        </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> login </span>
        <span class="block mt-[20px] md:mt-[35px]"> login </span>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] md:pt-[40px] rounded-md"
    >
      <div class="trezo-card-content text-center">
        <span class="material-symbols-outlined"> chevron_left </span>
        <span class="block mt-[20px] md:mt-[35px]"> chevron_left </span>
      </div>
    </div>
  </div>

  <div class="text-center mb-[25px]">
    <a
      href="https://fonts.google.com/icons"
      target="_blank"
      class="inline-block py-[12px] px-[30px] rounded-full bg-primary-500 text-white transition-all hover:bg-primary-400"
    >
      View All Icons
    </a>
  </div>
</template>

<script>
export default {
  name: "MaterialSymbols",
};
</script>
